import type { Branded } from "@@/utilities/branded";
import { genericId } from "@@/utilities/generic-id";

type UserAddressId = Branded<string, "UserAddressId">;
const userAddressIdPrefix = "user_address__";
const {
    zodSchema: userAddressIdZodSchema,
    factory: userAddressIdFactory,
    assert: isUserAddressId,
} = genericId<UserAddressId>(userAddressIdPrefix, {
    regexMatch: /^(useraddress_|user_address__).*$/,
});

export {
    isUserAddressId,
    userAddressIdFactory,
    userAddressIdPrefix,
    userAddressIdZodSchema,
};
export type { UserAddressId };
